import { EAccountPlansType } from "../../Enum/EAccountPlansType"
import { ECommercialOriginType } from "../../Enum/ECommercialOriginType"
import { AdminSubscriptionCase } from "./AdminSubscriptionCase"

export class AdminUpdateSubscription {
  planType: EAccountPlansType

  currentChargeAmount: number

  subscriptionStatus: string

  statusDetail?: string

  nextPaymentDate?: string

  lastPaymentStatus?: string

  lastPaymentDate?: string

  commercialOriginType: ECommercialOriginType

  commercialReferralCode?: string

  providerName?: string

  constructor(data: Partial<AdminUpdateSubscription> | AdminSubscriptionCase = {}) {
    this.planType = data.planType ?? EAccountPlansType.None

    this.currentChargeAmount = data.currentChargeAmount ?? 0

    this.subscriptionStatus = data.subscriptionStatus ?? ""

    this.statusDetail = data.statusDetail

    this.nextPaymentDate = data.nextPaymentDate

    this.lastPaymentStatus = data.lastPaymentStatus

    this.lastPaymentDate = data.lastPaymentDate

    this.commercialOriginType = data.commercialOriginType ?? ECommercialOriginType.Undefined

    this.commercialReferralCode = data.commercialReferralCode

    this.providerName = data.providerName
  }
}
